import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EympCourierpackagesRoutingModule } from './eymp-courierpackages-routing.module';
import { CourierPackageComponent } from './courier-package/courier-package.component';
import { CourierpackageSuccessComponent } from './courier-package/courierpackage-success/courierpackage-success.component';
import { CourierpackageFailureComponent } from './courier-package/courierpackage-failure/courierpackage-failure.component';
import { DocumentExtractionInfoComponent } from './courier-package/courierpackage-success/document-extraction-info/document-extraction-info.component';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FloatingLabelModule } from '@progress/kendo-angular-label';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { TreeListModule } from '@progress/kendo-angular-treelist';
import { DatePickerModule, DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DatePipe } from '@angular/common';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ListViewModule } from "@progress/kendo-angular-listview";
import { IconsModule } from "@progress/kendo-angular-icons";
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NotificationModule } from "@progress/kendo-angular-notification";
import { NavigationModule } from "@progress/kendo-angular-navigation";


@NgModule({
  declarations: [CourierPackageComponent, CourierpackageSuccessComponent, CourierpackageFailureComponent, DocumentExtractionInfoComponent],
  imports:[
    CommonModule,
    EympCourierpackagesRoutingModule,
    DialogModule,
    ExcelModule,
    GridModule,
    FormsModule,
    ReactiveFormsModule,
    DropDownsModule,
    FloatingLabelModule,
    TextBoxModule,
    InputsModule,
    TreeViewModule,
    TreeListModule,
    DatePickerModule,
    LayoutModule,
    DateInputsModule,
    ListViewModule,
    NotificationModule,
    IconsModule,
    MatAutocompleteModule,
    NavigationModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  providers: [DatePipe]
})

export class EympCourierpackagesModule { }
